angular
  .module 'gym.components'
  .directive 'contactColoredBar', ($stateParams) ->
    restrict: 'EA'
    link: ($scope, element) ->
      # add members-page or prospects-page class
      element.addClass "#{$stateParams.contactType}-page"
